import { useListAdesao, useSaveAdesao } from "./hooks";
import { cpfMask } from "utils/cpf";
import dayjs from "dayjs";

import { Button, FormControl, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, TextField } from "@mui/material";
import Loading from "components/loading";

import * as Styled from "./Adesoes.styled";

export function Adesoes() {
  const { data, isPending, handleChangeDate, handleChangePlan, handleCancelPlan } = useListAdesao();
  const { isPendingSave, isSuccessSave, handleSaveAdesao } = useSaveAdesao();

  return (
    <>
      {isPending && (
        <Styled.Loading>
          <Loading />
        </Styled.Loading>
      )}

      {data && (
        <Styled.Container>
          <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
            <Table>
              <TableHead>
                <TableRow style={{ height: '100px'}}>
                  <TableCell>CPF</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Data de nascimento</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Data de admissão</TableCell>
                  <TableCell>Vinculado ao CPF</TableCell>
                  <TableCell>Plano</TableCell>
                  <TableCell>Data de inicio do plano</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.data.map(person => (
                  <TableRow key={person.id} style={{ height: '100px'}}>
                    <Styled.Cell>{cpfMask(person.taxPayerId)}</Styled.Cell>
                    <Styled.Cell>{person.name}</Styled.Cell>
                    <Styled.Cell>{dayjs(person.birthDate).format('DD/MM/YYYY')}</Styled.Cell>
                    <Styled.Cell>{person.type === 'T' ? 'Titular' : 'Dependente'}</Styled.Cell>
                    <Styled.Cell>{person.hiringDate ? dayjs(person.hiringDate).format('DD/MM/YYYY') : '-'}</Styled.Cell>
                    <Styled.Cell>{person.linkedTaxPayerId ? cpfMask(person.linkedTaxPayerId) : ''}</Styled.Cell>
                    <Styled.Cell>
                      <FormControl style={{ width: '250px' }}>
                        <Select
                          variant="standard"
                          value={person.chosenPlan ?? ""}
                          onChange={e => handleChangePlan(person.id, e.target.value)}
                          disabled={isSuccessSave}
                          style={{ padding: '10px 0px 10px 0px' }}
                        >
                          <MenuItem value='NONE'>Sem Plano</MenuItem>
                          {person.plans.map(plan => (
                            <MenuItem key={`${plan.id}${person.id}`} value={plan.id}>{plan.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Styled.Cell>
                    <Styled.Cell>
                      <TextField
                        type='date'
                        variant='filled'
                        margin='normal'
                        value={person.selectedDate}
                        onChange={(e) => handleChangeDate(person.id, e.target.value)}
                      />
                    </Styled.Cell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Styled.ButtonContainer>
              <Button
                variant='text'
                color="error"
                style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                disabled={isPendingSave || isSuccessSave || !(data.data.find(person => person.wasModified === true))}
                onClick={handleCancelPlan}
              >
                Cancelar
              </Button>
              <Button
                variant='contained'
                style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                disabled={isPendingSave || isSuccessSave || !(data.data.find(person => person.wasModified === true))}
                onClick={() => handleSaveAdesao(data.data)}
              >
                {isPendingSave ? <CircularProgress  color='info' size={20}/> : 'Salvar'}
              </Button>
          </Styled.ButtonContainer>
        </Styled.Container>
      )}
    </>
  );
}
